export const MATKA_DATA = {
  Market: [
    {
      id: "mahadevi",
      name: "MAHADEVI",
      titleForGames: "Mahadevi Starline Games",
      status: "Bet is running for Close",
      numbers: "399-14-737",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "milan-day",
      name: "MILAN DAY",
      titleForGames: "Milan Day Games",
      status: "Bet is running for Close",
      numbers: "125-88-299",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "kalyan",
      name: "KALYAN",
      titleForGames: "Kalyan Games",
      status: "Bet is running for Close",
      numbers: "467-33-189",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "time-bazar",
      name: "TIME BAZAR",
      titleForGames: "Time Bazar Games",
      status: "Bet is running for Close",
      numbers: "100-50-600",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "rajdhani-night",
      name: "RAJDHANI NIGHT",
      titleForGames: "Rajdhani Night Games",
      status: "Bet is running for Close",
      numbers: "246-77-890",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "main-bazar",
      name: "MAIN BAZAR",
      titleForGames: "Main Bazar Games",
      status: "Bet is running for Close",
      numbers: "389-40-120",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "supreme-day",
      name: "SUPREME DAY",
      titleForGames: "Supreme Day Games",
      status: "Bet is running for Close",
      numbers: "148-52-963",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
    {
      id: "sridevi-night",
      name: "SRIDEVI NIGHT",
      titleForGames: "Sridevi Night Games",
      status: "Bet is running for Close",
      numbers: "579-22-446",
      openTime: "04:34 PM",
      closeTime: "04:34 PM",
      isOpen: true,
    },
  ],
  Starline: [
    {
      id: "starline-01",
      name: "01:00 PM STARLINE",
      titleForGames: "01:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "234-9",
      openTime: "12:30 PM",
      closeTime: "01:00 PM",
      isOpen: true,
    },
    {
      id: "starline-02",
      name: "02:00 PM STARLINE",
      titleForGames: "02:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "567-8",
      openTime: "01:30 PM",
      closeTime: "02:00 PM",
      isOpen: true,
    },
    {
      id: "starline-03",
      name: "03:00 PM STARLINE",
      titleForGames: "03:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "138-2",
      openTime: "02:30 PM",
      closeTime: "03:00 PM",
      isOpen: true,
    },
    {
      id: "starline-04",
      name: "04:00 PM STARLINE",
      titleForGames: "04:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "479-0",
      openTime: "03:30 PM",
      closeTime: "04:00 PM",
      isOpen: true,
    },
    {
      id: "starline-05",
      name: "05:00 PM STARLINE",
      titleForGames: "05:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "159-5",
      openTime: "04:30 PM",
      closeTime: "05:00 PM",
      isOpen: true,
    },
    {
      id: "starline-06",
      name: "06:00 PM STARLINE",
      titleForGames: "06:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "248-4",
      openTime: "05:30 PM",
      closeTime: "06:00 PM",
      isOpen: true,
    },
    {
      id: "starline-07",
      name: "07:00 PM STARLINE",
      titleForGames: "07:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "369-8",
      openTime: "06:30 PM",
      closeTime: "07:00 PM",
      isOpen: true,
    },
    {
      id: "starline-08",
      name: "08:00 PM STARLINE",
      titleForGames: "08:00 PM Starline Games",
      status: "Bet is running for Close",
      numbers: "127-0",
      openTime: "07:30 PM",
      closeTime: "08:00 PM",
      isOpen: true,
    },
  ],
  Jackpot: [
    {
      id: "jackpot-kalyan",
      name: "KALYAN JACKPOT",
      titleForGames: "Kalyan Jackpot Games",
      status: "Bet is running for Close",
      numbers: "148-52-963",
      openTime: "04:30 PM",
      closeTime: "06:30 PM",
      isOpen: true,
    },
    {
      id: "jackpot-main",
      name: "MAIN BAZAR JACKPOT",
      titleForGames: "Main Bazar Jackpot Games",
      status: "Bet is running for Close",
      numbers: "389-40-120",
      openTime: "09:30 PM",
      closeTime: "11:30 PM",
      isOpen: true,
    },
    {
      id: "jackpot-milan",
      name: "MILAN JACKPOT",
      titleForGames: "Milan Jackpot Games",
      status: "Bet is running for Close",
      numbers: "467-33-189",
      openTime: "02:30 PM",
      closeTime: "04:30 PM",
      isOpen: true,
    },
    {
      id: "jackpot-rajdhani",
      name: "RAJDHANI JACKPOT",
      titleForGames: "Rajdhani Jackpot Games",
      status: "Bet is running for Close",
      numbers: "579-22-446",
      openTime: "09:00 PM",
      closeTime: "11:00 PM",
      isOpen: true,
    },
  ],
};

export const GAME_TYPES = [
  {
    id: "single-digit",
    title: "Single Digit",
    subtitle: "Place your bets by entering points for each digit",
    icon: "single-digit",
    hasBulk: false,
  },
  {
    id: "single-digit-bulk",
    title: "Single Digit Bulk",
    subtitle: "Place multiple bets in bulk for single digits",
    icon: "single-digit",
    hasBulk: true,
  },
  {
    id: "jodi-digit",
    title: "Jodi Digit",
    subtitle: "Place bets on 2-digit jodi combinations",
    icon: "jodi-digit",
    hasBulk: false,
  },
  {
    id: "jodi-digit-bulk",
    title: "Jodi Digit Bulk",
    subtitle: "Place bulk bets on jodi combinations",
    icon: "jodi-digit",
    hasBulk: true,
  },
  {
    id: "single-pana",
    title: "Single Pana",
    subtitle: "Place bets on single pana combinations",
    icon: "single-pana",
    hasBulk: false,
  },
  {
    id: "single-pana-bulk",
    title: "Single Pana Bulk",
    subtitle: "Place bulk bets on single pana",
    icon: "single-pana",
    hasBulk: true,
  },
  {
    id: "double-pana",
    title: "Double Pana",
    subtitle: "Place bets on double pana combinations",
    icon: "double-pana",
    hasBulk: false,
  },
  {
    id: "double-pana-bulk",
    title: "Double Pana Bulk",
    subtitle: "Place bulk bets on double pana",
    icon: "double-pana",
    hasBulk: true,
  },
  {
    id: "triple-pana",
    title: "Triple Pana",
    subtitle: "Place bets on triple pana combinations",
    icon: "triple-pana",
    hasBulk: false,
  },
  {
    id: "sp-motor",
    title: "SP Motor",
    subtitle: "Place bets on SP motor combinations",
    icon: "sp-motor",
    hasBulk: false,
  },
  {
    id: "dp-motor",
    title: "DP Motor",
    subtitle: "Place bets on DP motor combinations",
    icon: "dp-motor",
    hasBulk: false,
  },
  {
    id: "group-jodi",
    title: "Group Jodi",
    subtitle: "Place bets on group jodi combinations",
    icon: "group-jodi",
    hasBulk: false,
  },
  {
    id: "sp-dp-tp",
    title: "SP DP TP",
    subtitle: "Place bets on SP DP TP combinations",
    icon: "sp-dp-tp",
    hasBulk: false,
  },
  {
    id: "odd-even",
    title: "Odd Even",
    subtitle: "Place bets on odd or even combinations",
    icon: "odd-even",
    hasBulk: false,
  },
  {
    id: "red-bracket",
    title: "Red Bracket",
    subtitle: "Place bets on red bracket combinations",
    icon: "red-bracket",
    hasBulk: false,
  },
  {
    id: "digit-based-jodi",
    title: "Digit Based Jodi",
    subtitle: "Place bets based on specific digit combinations",
    icon: "digit-based-jodi",
    hasBulk: false,
  },
  {
    id: "choice-pana",
    title: "Choice Pana",
    subtitle: "Choose custom pana to place bets",
    icon: "choice-pana",
    hasBulk: false,
  },
  {
    id: "panel-group",
    title: "Panel Group",
    subtitle: "Place bets on panel group sets",
    icon: "panel-group",
    hasBulk: false,
  },
  {
    id: "two-digit-panel",
    title: "Two Digit Panel (CP, SR)",
    subtitle: "Place bets on two digit panel combinations",
    icon: "two-digit-panel",
    hasBulk: false,
  },
  {
    id: "half-sangam-a",
    title: "Half Sangam A",
    subtitle: "Place bets on Half Sangam A combinations",
    icon: "half-sangam-a",
    hasBulk: false,
  },
  {
    id: "half-sangam-b",
    title: "Half Sangam B",
    subtitle: "Place bets on Half Sangam B combinations",
    icon: "half-sangam-b",
    hasBulk: false,
  },
  {
    id: "full-sangam",
    title: "Full Sangam",
    subtitle: "Place bets on Full Sangam combinations",
    icon: "full-sangam",
    hasBulk: false,
  },
];

export const SINGLE_DIGITS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

export const QUICK_MARKETS = [
  { id: "mahadevi", name: "Mahadevi", icon: "🍧" },
  { id: "milan-day", name: "Milan Day" },
  { id: "kalyan", name: "Kalyan" },
  { id: "time-bazar", name: "Time Bazar" },
];
